<template>
  <div class="payuMethodView">
    <payu-method></payu-method>
  </div>
</template>

<script>
// @ is an alias to /src
import payuMethod from "@/components/methods/payuMethod.vue";

export default {
  name: "payu",

  components: {
    payuMethod
  },
  created() {
    console.log("PayU");
  }
};
</script>


